import { render, staticRenderFns } from "./amount-payable.vue?vue&type=template&id=cd04b804&"
import script from "./amount-payable.vue?vue&type=script&lang=js&"
export * from "./amount-payable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports